"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

require("core-js/modules/es.array.join");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.replace");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _every = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/every"));

var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/index-of"));

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/json/stringify"));

var _isArray = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/array/is-array"));

var _defineProperty = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-property"));

var _assign = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/assign"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/typeof"));

/*eslint-disable */
var url = 'https://cecom.baidu.com/m/shop/sdk/choosegoods/#/';
var eventCount = 0;
var showClass = 'pc_goods_iframe';
var hideClass = 'pc_goods_iframe_none';
var cssUnits = ['%', 'rem', 'em', 'vh', 'vw', 'px'];
var ignoreConfig = ['devUrl', 'container', 'width', 'height'];

function isDOM(obj) {
  if ((typeof HTMLElement === "undefined" ? "undefined" : (0, _typeof2.default)(HTMLElement)) === 'object') {
    return obj instanceof HTMLElement;
  } else {
    return obj && (0, _typeof2.default)(obj) === 'object' && obj.nodeType === 1 && typeof obj.nodeName === 'string';
  }
}

function combine(target, source) {
  if (typeof _assign.default !== "function") {
    (0, _defineProperty.default)(Object, "assign", {
      value: function assign(target, varArgs) {
        "use strict";

        if (target === null || target === undefined) {
          throw new TypeError("Cannot convert undefined or null to object");
        }

        var to = Object(target);

        for (var index = 1; index < arguments.length; index++) {
          var nextSource = arguments[index];

          if (nextSource !== null && nextSource !== undefined) {
            for (var nextKey in nextSource) {
              // Avoid bugs when hasOwnProperty is shadowed
              if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                to[nextKey] = nextSource[nextKey];
              }
            }
          }
        }

        return to;
      },
      writable: true,
      configurable: true
    });
  }

  return (0, _assign.default)(target, source);
}

function isArray(val) {
  if (_isArray.default) {
    return (0, _isArray.default)(val);
  } else {
    return val instanceof Array;
  }
}

function executeFun(funcArr, data, _self) {
  var count, excFun, res; // 先处理下数据

  data = data || [];

  if (!isArray(funcArr)) {
    funcArr = [funcArr];
  }

  for (count = 0; count < funcArr.length; count++) {
    excFun = funcArr[count];

    try {
      res = excFun && excFun.call(_self, data);
    } catch (e) {
      console && console.error(e);
    }
  }

  return res;
}

function encodeParams(key, val) {
  key = encodeURIComponent(key);
  val = (0, _stringify.default)(val);
  val = encodeURIComponent(val);
  return key + ("" === val ? "" : "=" + val);
}

function parseIframeUrl() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var tmp = [];

  for (var key in config) {
    // 过滤掉iframe需要 组件不需要的参数 如container、devUrl
    if ((0, _indexOf.default)(ignoreConfig).call(ignoreConfig, key) === -1) {
      var val = config[key];

      if (val && val.constructor == Array) {
        for (var i = 0; i < val.length; i++) {
          tmp.push(encodeParams(key, val[i]));
        }
      } else {
        tmp.push(encodeParams(key, val));
      }
    }
  }

  var tmpUrl = config.devUrl ? config.devUrl : url;
  return tmpUrl + '?' + tmp.join("&");
}

function createIframe() {
  try {
    var _context3;

    var ifr = document.createElement("iframe");
    ifr.src = parseIframeUrl(this.config);
    ifr.className = showClass + (this.config.addClass ? " " + this.config.addClass : "") + (this.config.show ? "" : " " + hideClass);
    ifr.id = 'goods_iframe' + this.config.eventId; // 将this传给函数里面

    var that = this;

    ifr.onload = function () {
      that.endTime = new Date().getTime(); // 记录iframe加载时间

      console.log(that.endTime - that.startTime); // 执行回调

      if (typeof that.callback === 'function') {
        that.callback();
      }
    };

    var styleDom = document.createElement("style");
    styleDom.type = 'text/css';
    var widthHeight = "800px;height:600px;";

    if (this.config.width || this.config.height) {
      var width = this.config.width || 800;
      var height = this.config.height || 600; // 在这里过滤 100% rem em vw vh

      if ((0, _every.default)(cssUnits).call(cssUnits, function (item) {
        var _context;

        return (0, _indexOf.default)(_context = width + '').call(_context, item) === -1;
      })) {
        if (!isNaN(width)) {
          width = width + 'px;';
        } else {
          throw Error('width参数格式不正确');
        }
      } else {
        width = width + ';';
      }

      if ((0, _every.default)(cssUnits).call(cssUnits, function (item) {
        var _context2;

        return (0, _indexOf.default)(_context2 = height + '').call(_context2, item) === -1;
      })) {
        if (!isNaN(height)) {
          height = height + 'px;';
        } else {
          throw Error('height参数格式不正确');
        }
      } else {
        height = height + ';';
      }

      widthHeight = width + "height:" + height;
    }

    var showStyle = ".pc_goods_iframe{width:" + widthHeight + "border:none}.pc_goods_iframe_none{display:none;}";

    if ((0, _indexOf.default)(_context3 = navigator.userAgent).call(_context3, "MSIE 8.0") > 0) {
      styleDom.styleSheet.cssText = showStyle;
      document.getElementsByTagName("head")[0].appendChild(styleDom);
    } else {
      // bca-disable-line
      styleDom.innerHTML = showStyle;
      document.head.appendChild(styleDom);
    }

    if (this.config.container) {
      if (!isDOM(this.config.container)) {
        throw Error('container需要传入dom元素');
      }

      this.config.container.appendChild(ifr);
    } else {
      document.body.appendChild(ifr);
    }

    return ifr;
  } catch (e) {
    throw Error(e);
  }
}

function postMessagePackage() {
  var msg = 'message';

  var _self = this;

  var callback = function callback(e) {
    // 避免大量react-tools的信息
    if (/^react-devtools/gi.test(e.data.source)) {
      return;
    }

    var tmp;
    console && console.log && console.log(e);

    try {
      tmp = JSON.parse(e.data);
    } catch (e) {
      tmp = {};
    }

    if (tmp.eventId === _self.config.eventId) {
      _self.fire(tmp.type, tmp.data);
    }
  };

  window.addEventListener ? window.addEventListener(msg, callback, !1) : window.attachEvent ? window.attachEvent("on" + msg, callback) : window["on" + msg] = callback;
}

function GoodsIframe(params, callback) {
  if (!(this instanceof GoodsIframe)) return new GoodsIframe(params);
  this.startTime = new Date().getTime();
  this.config = combine({
    prod: '',
    color: "#3855D5",
    show: true,
    container: null,
    addClass: "",
    multichoose: false
  }, params); // 对数据进行处理

  if (!this.config.prod) {
    throw Error('缺少必要参数，请填写业务线名称');
  }

  this.config.color = this.config.color.replace(/^#/, "");
  this.config.eventId = "pc_goods_component" + ++eventCount;
  this.callback = callback; // 处理宽度和长度

  if (this.config.width && Object.prototype.toString.call(this.config.width) !== '[object String]' && Object.prototype.toString.call(this.config.width) !== '[object Number]') {
    throw Error('width参数为字符串或数字类型');
  }

  if (this.config.height && Object.prototype.toString.call(this.config.height) !== '[object String]' && Object.prototype.toString.call(this.config.height) !== '[object Number]') {
    throw Error('height参数为字符串或数字类型');
  } // 创建iframe


  this.iframe = createIframe.call(this); // postMessage 方法封装

  postMessagePackage.call(this);
}

GoodsIframe.prototype.fire = function (type, data) {
  var emitTarget = this["\x1e" + type];
  data = data || {};

  if (emitTarget) {
    var index,
        len = emitTarget.length;

    for (index = 0; index < len; index++) {
      var func = emitTarget[index].func;

      if (func) {
        executeFun(func, data, this);
      }
    }
  }
};

GoodsIframe.prototype.on = function (type, callback) {
  var tmpType = "\x1e" + type;
  (this[tmpType] || (this[tmpType] = [])).push({
    func: callback
  });
};

GoodsIframe.prototype.off = function (type, callback) {
  var index,
      tmpType = "\x1e" + type,
      eventArr = this[tmpType];

  if (callback) {
    if (eventArr) {
      for (index = eventArr.length; index--;) {
        if (eventArr[index].func === callback) {
          eventArr[index].func = "";
          break;
        }
      }
    }
  } else {
    delete this[tmpType];
  }
};

GoodsIframe.prototype.destory = function () {
  this.iframe.remove();
};

var _default = GoodsIframe;
exports.default = _default;